import { ReactNode } from 'react';

interface NumCountProps {
  count: ReactNode;
}

export function NumCount({ count }: NumCountProps) {
  return <span className="text-[34px] font-medium leading-none text-[#9e9e9e]">{count}</span>;
}
